import { render, staticRenderFns } from "./shopExamine.vue?vue&type=template&id=3198477e&scoped=true"
import script from "./shopExamine.vue?vue&type=script&lang=js"
export * from "./shopExamine.vue?vue&type=script&lang=js"
import style0 from "./shopExamine.vue?vue&type=style&index=0&id=3198477e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3198477e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3198477e')) {
      api.createRecord('3198477e', component.options)
    } else {
      api.reload('3198477e', component.options)
    }
    module.hot.accept("./shopExamine.vue?vue&type=template&id=3198477e&scoped=true", function () {
      api.rerender('3198477e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/shopExamine.vue"
export default component.exports